import { render, staticRenderFns } from "./PageWallet.vue?vue&type=template&id=1f0207e6&scoped=true&"
import script from "./PageWallet.vue?vue&type=script&lang=js&"
export * from "./PageWallet.vue?vue&type=script&lang=js&"
import style0 from "./PageWallet.vue?vue&type=style&index=0&id=1f0207e6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0207e6",
  null
  
)

export default component.exports